import { Space } from "components/Common/Space";
import { ExerciseHeader } from "components/Common/ExerciseHeader";
import {
  useUpdateChapterStudentProgress,
  useUpdateHomeworkStudentProgress,
} from "hooks/api/student-progress";
import { useRole } from "hooks/common";
import { useParams } from "react-router-dom";
import { SentenceList } from "./SentenceList";
import {
  TInputWordsIntoGapsExercise,
  TInputWordsIntoGapsExercisePayload,
} from "types/app/exercises";
import "./InputWordsIntoGaps.styles.scss";

type TInputWordsIntoGapsProps = {
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TInputWordsIntoGapsExercise;
  isHomeworkExercise: boolean;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
};

export const InputWordsIntoGaps: React.FC<TInputWordsIntoGapsProps> = (
  props
) => {
  const { chapterId, exercise, prefix = null, isHomeworkExercise } = props;

  const { courseId, lessonId, studentId } = useParams();
  const { isUserStudent } = useRole();

  const { mutate: updateChapterProgress } = useUpdateChapterStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );
  const { mutate: updateHomeworkProgress } = useUpdateHomeworkStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );

  const handleSaveExercise = (updatedExercise: TInputWordsIntoGapsExercise) => {
    if (!isUserStudent || !studentId) return;

    if (isHomeworkExercise) {
      updateHomeworkProgress(updatedExercise);
    } else {
      updateChapterProgress(updatedExercise);
    }
  };

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TInputWordsIntoGapsExercisePayload>
        chapterId={chapterId}
        exercise={exercise}
        prefix={prefix}
      />
      <SentenceList
        sentences={exercise.payload.data.sentences}
        exercise={exercise}
        onSaveExercise={handleSaveExercise}
      />
    </Space>
  );
};
